import React, { useEffect, useState } from 'react'
import Loader from '../components/Loader'
import { userInquiryData, userRegister } from "./../api/userInquiry"
import { useNavigate } from 'react-router-dom';

export default function UserInquiry() {
    const [loading, setLoading] = useState(false);
    const [apiError, setApiError] = useState('');
    const [errorStatus, setErrorStatus] = useState("success");
    const [userInquiryList, setUserInquiryList] = useState([]);
    const navigate = useNavigate();

    const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
    const getInquiryData = async () => {
        let inQuiryData = await userInquiryData();
        if (inQuiryData.status > 199 && inQuiryData.status < 400) {
            setUserInquiryList(inQuiryData.data.data)
        }
    }
    useEffect(() => {
        getInquiryData();
    }, []);

    const convertDate = (isoDate) => {
        // const isoDate = "2025-06-10T04:50:39.250Z";
        const date = new Date(isoDate);

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = date.getFullYear();

        const formattedDate = `${day}-${month}-${year}`;
        return formattedDate
    }

    const arrayToString = (arr) => {
        return arr.join(' , ')
    }
    const handleEditBtn = async (obj) => {
        navigate(`/registration/${obj._id}/mmregister`)
    }
    const handleApproveBtn = async (obj) => {

        let data = {
            "DecEORINumber": obj["eoriNumber"],
            "DecName": obj["company"],
            "DecAddress": obj["address"],
            "DecCity": obj["city"],
            "DecPostalCode": obj["postcode"],
            "DecCountry": obj["country"],
            "DecEmail": obj["email"],
            "FullName": obj["firstName"] + " " + obj["lastName"],
            "email": obj["email"],
            "Address": obj["address"],
            "uType": obj["traderOrAgent"],
            "password": "Welcome1",
            "nextSystemUser": obj["email"],
            "system": "Tdr",
            "systemList": [],
            "roles": ["Customs"]
        }

        setLoading(true)
        let registerData = await userRegister(data);
        setLoading(false);
        if (registerData.status > 199 && registerData.status < 400) {

            setApiError("Create user successfully..")
            setErrorStatus("success")
            await delay(5000);
            setApiError("");
        } else {
            setApiError("There are some technical issue, please try again after sometime...")
            setErrorStatus('danger')
            await delay(5000);
            setApiError("");
        }
    }
    return (
        <>
            {loading && <Loader />}
            <div className="content-wrapper">
                {apiError && <div className={`alert alert-${errorStatus} mb-4`}> {apiError}</div>}


                <div className="col-lg-12 grid-margin stretch-card">

                    <div className="card">
                        <div className="card-body">
                            <h4 className="card-title">User List</h4>



                            <div className="table-responsive ">
                                <table className="table table-bordered table-hover">
                                    <thead>
                                        <tr>
                                            <th> # </th>
                                            <th> Inquiry </th>
                                            <th> Name </th>
                                            <th> City </th>
                                            <th> Email </th>
                                            <th> Type </th>
                                            <th> Process </th>
                                            <th> Date </th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {userInquiryList.map((obj, index) => (
                                            <tr key={obj._id}>
                                                <td> {index + 1} </td>
                                                <td> {obj.inquiryType} </td>
                                                <td> {obj?.firstName} </td>
                                                <td> {obj?.city} </td>
                                                <td> {obj.email} </td>
                                                <td> {obj.traderOrAgent} </td>
                                                <td> {arrayToString(obj.customsProcesses)} </td>
                                                <td> {convertDate(obj.createdAt)} </td>
                                                <td>
                                                    {
                                                        obj?.status && obj.status === "user-created"
                                                            ? <button style={{ marginLeft: "10px" }} type="button" className="btn btn-danger me-2" >User Created</button>
                                                            : ""
                                                    }
                                                    <button style={{ marginLeft: "10px" }} type="button" onClick={() => handleEditBtn(obj)} className="btn btn-success me-2" >Register</button>

                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
